const displayData = [
    {
        "id": 1,
        "placeName": "Cox's bazar",
        "img": "https://i.ibb.co/VHmx3mD/Rectangle-1.png",
        "shortDescription": "Cox’s Bazar is a town on the southeast coast of Bangladesh. "
    }, {
        "id": 2,
        "placeName": "Sylet",
        "img": "https://i.ibb.co/D50BB10/Sreemongol.png",
        "shortDescription": "Sylhet is a city in eastern Bangladesh, on the Surma River.  "
    }, {
        "id": 3,
        "placeName": "Sundarban",
        "img": "https://i.ibb.co/ZfWhNmT/sundorbon.png",
        "shortDescription": "Beach in the south. Aggameda Khyang monastery is home  ."
    }
]

export default displayData;